import React, {useState, useEffect, useContext, useRef} from 'react';
import CompanyContext from '../../contexts/companyContext';
import styles from './css/about.module.css';
import { FaMapMarkerAlt, FaWhatsapp, FaPhoneAlt, FaEnvelope, FaRegClock } from "react-icons/fa";
import AddressMap from '../../components/addressMap';
import Loader from '../../components/loader';
import ReturnButton from '../../components/returnButton';


export default function About(){

    const {companyData} = useContext(CompanyContext);
    const [loading, setLoading] = useState(false);
    const [mapsLink, setMapsLink] = useState(null);
    const [wppLink, setWppLink] = useState(null);



    useEffect(() => {
        const address = `${companyData.street}, ${companyData.number}, ${companyData.state}, ${companyData.cep}`;
        setMapsLink(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`);
    
        if(companyData.phone){
            const formatPhone = companyData.phone.replace('(', '').replace(')', '').replaceAll(' ', '').replace('-', '');
            setWppLink(`https://wa.me/55${formatPhone}`);
        }
    }, [])




    // LINK DE LIGAÇÃO
    const telLink = `tel:+55${(companyData.phone ?? '').replace(/\D/g, '')}`;


    return(
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div>


                    {/* <======================= HEADER =======================> */}
                    <header className={styles.headerAbout} style={{ backgroundColor: companyData.background_color }}>
                        <ReturnButton background={companyData.text_color} color={companyData.background_color}/>
                        <h1 className={styles.titleAbout} style={{ color: companyData.text_color }}>Sobre nós</h1>
                    </header>


                    <div className={styles.container}>

                        {companyData.show_service && companyData.service_information && (
                            <section className={styles.informationSection}>
                                <p className={styles.titleSection}><FaRegClock size={16} />Horário de atendimento</p>

                                <p className={styles.serviceText}>
                                    {companyData.service_information.split('\n').map((line, i, arr) => (
                                        <React.Fragment key={i}>
                                            {line}
                                            {i < arr.length - 1 && <br />}
                                        </React.Fragment>
                                    ))}
                                </p>
                            </section>

                        )}

                        {(companyData.show_comercial_phone || companyData.show_comercial_email) && (
                            <section className={styles.informationSection}>
                                <p className={styles.titleSection}><FaPhoneAlt size={15} />Contato</p>

                                {companyData.show_comercial_phone && (
                                    <a href={telLink} className={styles.contactRow}>
                                        <FaPhoneAlt size={14} color='#444' />
                                        <p className={styles.contactRowText}>{companyData.phone}</p>
                                    </a>
                                )}

                                {companyData.show_comercial_email && (
                                    <a href={`mailto:${companyData.email}`} className={styles.contactRow}>
                                        <FaEnvelope size={14} color='#444' />
                                        <p className={styles.contactRowText}>{companyData.email}</p>
                                    </a>
                                )}

                                {companyData.show_comercial_phone && (
                                    <a
                                        href={wppLink}
                                        className={styles.mapsButton}
                                        style={{backgroundColor: '#25D366'}}
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        <FaWhatsapp size={20} color='#fff'/>
                                        <p className={styles.mapsButtonText} style={{color: '#fff'}}>Whatsapp</p>
                                    </a>
                                )}
                            </section>
                        )}


                        {companyData.show_address ? (
                            <section className={styles.informationSection}>
                                <p className={styles.titleSection}><FaMapMarkerAlt size={16} />Endereço</p>

                                <p className={`${styles.textSection} ${styles.addressText}`}>Rua {companyData.street}, {companyData.number} - {companyData.district}, {companyData.city} - {companyData.state}, {companyData.cep} - Brasil</p>

                                <div className={styles.mapWrapper}>
                                    <AddressMap
                                        latitude={companyData.latitude}
                                        longitude={companyData.longitude}
                                        color={companyData.background_color}
                                    />
                                </div>

                                <a href={mapsLink} className={styles.mapsButton} style={{backgroundColor: companyData.background_color}}>
                                    <FaMapMarkerAlt size={18} color={companyData.text_color}/>
                                    <p className={styles.mapsButtonText} style={{color: companyData.text_color}}>Abrir no maps</p>
                                </a>
                            </section>
                        ) : null}

                    </div>
                </div>
            )}

        </div>
    )
}